<template>
  <div class="moment">
    <h1>{{$t('home.momentTitle')}}</h1>
    <p>{{$t('home.momentContent')}}</p>
    <div class="time_list">
      <img
        :class="{'mar_r_0': (index+1)%4==0,'mar_b_0':index>=4}"
        :src="item"
        alt
        v-for="(item,index) in img_list"
        :key="index"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img_list: [
        require("@/assets/images/img_1.png"),
        require("@/assets/images/img_2.png"),
        require("@/assets/images/img_3.png"),
        require("@/assets/images/img_4.png"),
        require("@/assets/images/img_5.png"),
        require("@/assets/images/img_6.png"),
        require("@/assets/images/img_7.png"),
        require("@/assets/images/img_8.png")
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.moment {
  width: 1200px;
  margin: auto;
  padding: 64px 0 80px;
  & h1 {
    margin-bottom: 10px;
  }
  & p {
    font-size: 20px;
    color: #666666;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 48px;
  }
  & .time_list {
    & img {
      width: 297px;
      height: 180px;
      margin-right: 4px;
      margin-bottom: 4px;
    }
    & .mar_r_0 {
      margin-right: 0px !important;
    }
    & .mar_b_0 {
      margin-bottom: 0px !important;
    }
  }
}
</style>